// ################## Score - Before Creation ##################
export const scoreItemTypes = ['simpleValue', 'bloodPressure'];
//# sourceMappingURL=types.js.map